<template>
  <v-form ref="form" onsubmit="return false;">
    <!-- About company -->

    <v-text-field
      v-model="company.title"
      :label="$t('rms.field.title.label')"
      color="saPrimary"
      :rules="[rules.required, rules.min_length(3), rules.max_length(250)]"
      counter="250"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="grey--text text--darken-3 body-1">
            {{ $t("company.save.title.tooltip") }}
          </div>
        </v-tooltip>
      </template></v-text-field
    >
    <v-text-field
      v-model="company.slug"
      color="saPrimary"
      :label="$t('rms.field.slug.label')"
      :rules="[
        rules.required,
        rules.min_length(2),
        rules.max_length(15),
        rules.subdomain,
      ]"
      :hint="$t('company.save.slug.hint')"
      counter="15"
      ><template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="grey--text text--darken-3 body-1">
            {{ $t("company.save.slug.tooltip") }}
          </div>
        </v-tooltip>
      </template></v-text-field
    >
    <v-text-field
      :value="company.domain"
      color="saPrimary"
      :label="$t('company.access_url.title')"
      readonly
      ><template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="grey--text text--darken-3 body-1">
            {{ $t("company.save.domain.tooltip") }}
          </div>
        </v-tooltip>
      </template></v-text-field
    >
    <v-text-field
      v-model="company.notes"
      color="saPrimary"
      :label="$t('company.save.description.title')"
      :rules="[rules.max_length(250)]"
      counter="250"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="grey--text text--darken-3 body-1">
            {{ $t("company.save.description.tooltip") }}
          </div>
        </v-tooltip>
      </template></v-text-field
    >
    <!-- Creator role -->
    <v-autocomplete
      v-model="company.creator_role"
      :items="DEFINES.COMPANY_CREATOR_ROLE"
      item-text="text"
      item-value="value"
      :label="$t('company.save.creator_role.title')"
      color="saPrimary"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="grey--text text--darken-3 body-1">
            {{ $t("company.save.creator_role.tooltip") }}
          </div>
        </v-tooltip>
      </template>
    </v-autocomplete>
    <v-select
      :items="DEFINES.LOCALES"
      v-model="company.custom_properties.language"
      :label="$t('screener.save.form.theme.language')"
      color="saPrimary"
    ></v-select>
    <v-autocomplete
      v-model="company.custom_properties.timezone"
      :items="DEFINES.SUPPORTED_TIMEZONES"
      color="saPrimary"
      :label="$t('screener.admin.company.select_timezone')"
    >
      <template v-slot:selection="data">
        {{ data.item }}
        {{ momentTz.tz(data.item).format("Z z") }}
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          {{ data.item }}
          {{ momentTz.tz(data.item).format("Z z") }}
        </template>
      </template>
    </v-autocomplete>
    <!-- Meta keywords -->
    <v-text-field
      id="meta_keywords"
      :label="$t('company.save.meta_keywords.title')"
      :placeholder="$t('company.save.meta_keywords.placeholder')"
      name="notes"
      type="text"
      v-model="company.meta_info.keywords"
      class="custom-placeholer-color"
      color="saPrimary"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="grey--text text--darken-3 body-1">
            {{ $t("company.save.meta_keywords.tooltip") }}
          </div>
        </v-tooltip>
      </template>
    </v-text-field>
    <v-switch
      v-model="company.is_listed"
      :label="'List the organization on homepage'"
      color="saPrimary"
    ></v-switch>
  </v-form>
</template>

<script>
import i18n from "@/i18n";
import rules from "@/validation";
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";
import { getCurrencySymbol, timezonesByCountry } from "@/helper";

export default {
  name: "AdminCompanyProfileBasicInfo",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { rules };
  },
  watch: {
    company: {
      handler: function () {
        this.$emit("update:company", this.company);
      },
      deep: true,
    },
  },
  methods:{
    _timezones(){
      return timezonesByCountry();
    },
  }
};
</script>

<style>
</style>
